import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ApiService } from './api.service'
import { unwrapCrudList, type CrudListResponse } from '../common/utils/crud-response.util'

export interface ContractDoctorChannelRecord {
  id: number | string
  contractDoctorId: number | string
  channelId: string
}

@Injectable({ providedIn: 'root' })
export class ContractDoctorChannelService {
  private readonly url = 'contract-doctor-channels'
  constructor(private api: ApiService) {}

  getByContractDoctor(
    contractDoctorId: number | string,
    options?: { cacheBust?: boolean },
  ): Observable<ContractDoctorChannelRecord[]> {
    // `scope=contract` invalidates stale Redis entries that returned all doctor channels.
    const bust = options?.cacheBust ? `&_cb=${Date.now()}` : ''
    return this.api
      .get<
        CrudListResponse<ContractDoctorChannelRecord>
      >(`${this.url}?filter=contractDoctorId||$eq||${contractDoctorId}&limit=1000&scope=contract${bust}`)
      .pipe(map((res) => unwrapCrudList(res)))
  }

  create(contractDoctorId: number | string, channelId: string): Observable<ContractDoctorChannelRecord> {
    return this.api.post<ContractDoctorChannelRecord>(this.url, { contractDoctorId, channelId })
  }

  delete(id: number | string): Observable<void> {
    return this.api.delete<void>(`${this.url}/${id}`)
  }
}
